import { createSlice } from "@reduxjs/toolkit";

export const setActiveOrganisationId = (activeOrganisationId) => {
  return {
    type: activeOrganisationIdSet.type,
    payload: {
      activeOrganisationId,
    },
  };
};

export const setActiveAppSpaceId = (activeAppSpaceId) => {
  return {
    type: activeAppSpaceIdSet.type,
    payload: {
      activeAppSpaceId,
    },
  };
};

//
//Store Slice Creator
//

const slice = createSlice({
  name: "organisationReducer",
  initialState: {
    activeOrganisationId: null,
    activeAppSpaceId: null,
    activeTenantId: null,
  },
  reducers: {
    activeAppSpaceIdSet: (organisations, action) => {
      organisations.activeAppSpaceId = action.payload.activeAppSpaceId;
    },
    activeOrganisationIdSet: (organisations, action) => {
      organisations.activeOrganisationId = action.payload.activeOrganisationId;
    },
  },
});

export const {
  activeTenantIdSet,
  activeOrganisationIdSet,
  activeAppSpaceIdSet,
} = slice.actions;

export default slice.reducer;
